/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument } from './CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument';
import {
    CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentFromJSON,
    CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentFromJSONTyped,
    CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentToJSON,
    CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentToJSONTyped,
} from './CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument';

/**
 * 
 * @export
 * @interface MatrixCarePatientDetailsDocumentsGeneratedDocumentsInner
 */
export interface MatrixCarePatientDetailsDocumentsGeneratedDocumentsInner {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    lead_id?: string;
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    s3_key?: string;
    /**
     * 
     */
    generated_at?: string;
    /**
     * 
     */
    previous_generated_at?: string;
    /**
     * 
     */
    type?: MatrixCarePatientDetailsDocumentsGeneratedDocumentsInnerTypeEnum;
    /**
     * 
     */
    instance_id?: string;
    /**
     * True when this document is stale enough that regenerating it would fetch fresh data instead of re-serving the cached copy.
     */
    can_regenerate?: boolean;
    /**
     * 
     */
    external_ehr_document?: CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocument;
}


/**
 * @export
 */
export const MatrixCarePatientDetailsDocumentsGeneratedDocumentsInnerTypeEnum = {
    SummaryReport: 'summary_report',
    RulesReport: 'rules_report',
    DataPullsReport: 'data_pulls_report',
    SOffenderReport: 's_offender_report',
    MedicationsReport: 'medications_report',
    InsuranceEligibilityCheck: 'insurance_eligibility_check',
    AdvancedAiInsuranceCheck: 'advanced_ai_insurance_check',
    PalAuthSubmissionPackage: 'pal_auth_submission_package',
    PalCarveOutsPackage: 'pal_carve_outs_package',
    PalReauthSubmissionPackage: 'pal_reauth_submission_package',
    PdpmReport: 'pdpm_report',
    PccFaceSheetReport: 'pcc_face_sheet_report',
    PccOrderSummaryReport: 'pcc_order_summary_report',
    PccMdHistoryReport: 'pcc_md_history_report',
    PccDailySkilledNoteReport: 'pcc_daily_skilled_note_report',
    PccProgressNotesReport: 'pcc_progress_notes_report',
    PccWeightsVitalsReport: 'pcc_weights_vitals_report',
    PccLabResultsReport: 'pcc_lab_results_report',
    PccSocialServicesReport: 'pcc_social_services_report',
    PccSkinCheckReport: 'pcc_skin_check_report',
} as const;
export type MatrixCarePatientDetailsDocumentsGeneratedDocumentsInnerTypeEnum = typeof MatrixCarePatientDetailsDocumentsGeneratedDocumentsInnerTypeEnum[keyof typeof MatrixCarePatientDetailsDocumentsGeneratedDocumentsInnerTypeEnum];


/**
 * Check if a given object implements the MatrixCarePatientDetailsDocumentsGeneratedDocumentsInner interface.
 */
export function instanceOfMatrixCarePatientDetailsDocumentsGeneratedDocumentsInner(value: object): value is MatrixCarePatientDetailsDocumentsGeneratedDocumentsInner {
    return true;
}

export function MatrixCarePatientDetailsDocumentsGeneratedDocumentsInnerFromJSON(json: any): MatrixCarePatientDetailsDocumentsGeneratedDocumentsInner {
    return MatrixCarePatientDetailsDocumentsGeneratedDocumentsInnerFromJSONTyped(json, false);
}

export function MatrixCarePatientDetailsDocumentsGeneratedDocumentsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatrixCarePatientDetailsDocumentsGeneratedDocumentsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'lead_id': json['lead_id'] == null ? undefined : json['lead_id'],
        'name': json['name'] == null ? undefined : json['name'],
        's3_key': json['s3_key'] == null ? undefined : json['s3_key'],
        'generated_at': json['generated_at'] == null ? undefined : json['generated_at'],
        'previous_generated_at': json['previous_generated_at'] == null ? undefined : json['previous_generated_at'],
        'type': json['type'] == null ? undefined : json['type'],
        'instance_id': json['instance_id'] == null ? undefined : json['instance_id'],
        'can_regenerate': json['can_regenerate'] == null ? undefined : json['can_regenerate'],
        'external_ehr_document': json['external_ehr_document'] == null ? undefined : CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentFromJSON(json['external_ehr_document']),
    };
}

export function MatrixCarePatientDetailsDocumentsGeneratedDocumentsInnerToJSON(json: any): MatrixCarePatientDetailsDocumentsGeneratedDocumentsInner {
    return MatrixCarePatientDetailsDocumentsGeneratedDocumentsInnerToJSONTyped(json, false);
}

export function MatrixCarePatientDetailsDocumentsGeneratedDocumentsInnerToJSONTyped(value?: MatrixCarePatientDetailsDocumentsGeneratedDocumentsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'name': value['name'],
        's3_key': value['s3_key'],
        'generated_at': value['generated_at'],
        'previous_generated_at': value['previous_generated_at'],
        'type': value['type'],
        'instance_id': value['instance_id'],
        'can_regenerate': value['can_regenerate'],
        'external_ehr_document': CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerExternalEhrDocumentToJSON(value['external_ehr_document']),
    };
}

